import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import { useLocale } from '@/i18n/LocaleContext';
import { useAdvertisedCouponQuery } from '@/services/api/couponsApi';
import { formatMoney } from '@/shared/format';

/**
 * Announces the one coupon an administrator has chosen to feature, if any —
 * entirely data-driven, so there is no separate admin toggle to hide it: an
 * empty response (nothing advertised, or the featured coupon has since
 * expired) already renders nothing.
 */
export function CouponBanner() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { data: coupon } = useAdvertisedCouponQuery();

  if (!coupon) return null;

  const discount =
    coupon.discountType === 'PERCENTAGE'
      ? t('home.couponBanner.percentOff', { value: coupon.discountValue })
      : t('home.couponBanner.amountOff', {
          value: coupon.fixedAmount ? formatMoney(coupon.fixedAmount, locale) : '',
        });

  return (
    <Container maxWidth="lg" sx={{ pt: 2 }}>
      <Alert severity="info">{t('home.couponBanner.message', { discount, code: coupon.code })}</Alert>
    </Container>
  );
}

export default CouponBanner;
